import React, { Component } from 'react'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  unix2date7,
  jumpToRoom,
  inject,
  observer
} from '../../../helper/devTools.js'

import { history } from 'src/core/router'
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';

import Message from '../../../component/Message'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { isRtl } from 'src/helper/tool'

dayjs.extend(localizedFormat)

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.partyStore = this.props.store.register('app/partyStore')
    // setDocumentTitle(`Let's party`)
  }
  state = {
    lang: {},
    messageTxt: "",
    roomList: [],
    myPubList: [],
    language:'en',
    cannotCreatelang: {
      zh: "您已经创建了活动，今天无法再创建活动",
      en: 'You have already created an event and cannot create another one today!',
      tr: 'Bugün birşey oluşturdunuz ve başka birşey oluşturamazsınız.',
      ar: 'لقد قمت بالفعل بإنشاء حدث ولا يمكن إنشاء حدث آخر اليوم!'
    },
    letsParty: {
      tr: 'Hadi Parti Yapalım',
      ar: 'دعونا نحتفل',
      en: "Let's party"
    }
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, this.partyStore.data.lang),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }
  async getRoomList() {
    let res = await this.partyStore.apiGetPartyRoomList()
    // console.log('%c [ res ]-60', 'font-size:20px; background:pink; color:#bf2c9f;', res.res)
    // res.res[0].isSelfRoom = false
    if (res && res.code == 0) {
      this.setState({
        roomList: res && res.res
      })
    }
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    this.getRoomList()
    await this.RunOnStart(uid)
  }


  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    if (this.state.language == 'tr') {
      setDocumentTitle(this.state.letsParty.tr || `Let's party`)
    } else if (this.state.language == 'ar') {
      setDocumentTitle(this.state.letsParty.ar || `Let's party`)
    } else {
      setDocumentTitle(`Let's party`)
    }
    try {
      this.setState({
        uid: uid
      })
      let getUserInfo = await this.partyStore.GetUserInfoWeb(uid)
      let pubList = await this.partyStore.apiGetPubList()
      if (getUserInfo && getUserInfo.code == 0) {
        this.setState({
          userInfo: getUserInfo.res,
          myPubList: pubList && pubList.res
        })
      }

    } catch (error) {
      console.error(error)
      this.refs.msg.show(error)
    }
  }

  goCreate() {
    let temp = 0
    this.state.myPubList.map((e) => {
      if (e.status == 0 || e.status == 2) {
        temp++
      }
    })
    if (temp >= 2) {
      if (this.state.language == 'zh') {
        this.refs.msg.show(this.state.cannotCreatelang.zh)
      } else if (this.state.language == 'tr') {
        this.refs.msg.show(this.state.cannotCreatelang.tr)
      } else if (this.state.language == 'ar') {
        this.refs.msg.show(this.state.cannotCreatelang.ar)
      } else {
        this.refs.msg.show(this.state.cannotCreatelang.en)
      }
    } else {
      let { language, accesstoken, uid } = this.props.location.query
      history.push(`/app/partycreate?language=${this.state.language}`)
    }
  }


  async handleAdd(e, id, i) {
    e.stopPropagation()
    let res = await this.partyStore.apiHandleSubRoom(id)
    if (res && res.code == 0) {
      this.refs.msg.show(this.state.lang.Suc3)
      i.isSelfRoom = true;
      let tempArr = this.state.roomList
      this.setState({
        roomList: tempArr
      })
    } else {
      this.refs.msg.show(res && res.msg)
    }
  }

  async handleUnAdd(e, id, i) {
    e.stopPropagation()
    let res = await this.partyStore.apiHandleUnSubRoom(id)
    if (res && res.code == 0) {
      this.refs.msg.show(this.state.lang.Suc1)
      i.isSelfRoom = false;
      let tempArr = this.state.roomList
      this.setState({
        roomList: tempArr
      })

    } else {
      this.refs.msg.show(res && res.msg)
    }
  }

  handleToRoom(gId) {
    jumpToRoom(gId)
  }

  render() {

    return (
      <div className={`party-room-container ${isRtl(this.state.language) && 'arlang'}`}>
        <Message ref="msg" />
        <div className="banner-container">
          <div className="txt"></div>
          <div className="sl"></div>
          <div className="sr"></div>
          <img className="wu" src="/img/app/partyroom/wu.png" alt="" />
          <img className="yf1" src="/img/app/partyroom/yf2.png" alt="" />
          <img className="yf2" src="/img/app/partyroom/yf1.png" alt="" />
          <img className="cl" src="/img/app/partyroom/circle.png" alt="" />
          <img className="cr" src="/img/app/partyroom/circle.png" alt="" />
          <img className="light1" src="/img/app/partyroom/light1.png" alt="" />
          <img className="light2" src="/img/app/partyroom/light2.png" alt="" />
          <img className="light3" src="/img/app/partyroom/light3.png" alt="" />
          <img className="light4" src="/img/app/partyroom/light4.png" alt="" />
          <div className="btn" onClick={() => { history.push(`/app/partysub?language=${this.state.language}`) }}>
            <span style={{ margin: `${isRtl(this.state.language) ? "0 0.1rem" : "0 0.1rem"}` }}>{this.state.lang.sub}</span>
          </div>
        </div>
        <div className="room-items">
          {
            this.state.roomList && this.state.roomList.length > 10 && this.state.roomList.map((i) => {
              return (
                <div key={i.id} className="item" onClick={() => { this.handleToRoom(i.gid) }}>
                  <div className="pic">
                    <img src={i.image} alt="" />
                    {
                      !(i.isSelfRoom) && (
                        <div className="add" onClick={(e) => { this.handleAdd(e, i.id, i) }}></div>
                      )
                    }
                    {(i.isSelfRoom) && (
                      <div className='unsub' onClick={(e) => { this.handleUnAdd(e, i.id, i) }}></div>
                    )}
                    <div className="ball"></div>
                    <div className="hour" style={{ width: `${i.countDown ? "1.2rem" : "1.8rem"}` }}>
                      <div className="icon"></div>
                      <span>
                        {
                          i.countDown
                            ? i.countDown
                            : dayjs(i.startTime * 1000).format('MM-DD h:mm a')
                        }
                      </span>
                    </div>
                  </div>
                  <div className="room-info">
                    <div className="name">{i.name}</div>
                    <div className="desc">{i.description}</div>
                  </div>
                </div>
              )
            })
          }
          {
            this.state.roomList && this.state.roomList.length <= 10 && this.state.roomList.map((i) => {
              return (
                <div className="item-other" key={i.id} onClick={() => { this.handleToRoom(i.gid) }}>
                  <div className="pic">
                    <img src={i.image} alt="" />
                    {
                      !(i.isSelfRoom) && (
                        <div className="add" onClick={(e) => { this.handleAdd(e, i.id, i) }}></div>
                      )
                    }
                    {(i.isSelfRoom) && (
                      <div className='unsub' onClick={(e) => { this.handleUnAdd(e, i.id, i) }}></div>
                    )}

                    <div className="ball"></div>
                    <div className="hour" style={{ width: `${i.countDown ? "1.2rem" : "1.9rem"}` }}>
                      <div className="icon"></div>
                      <span>
                        {
                          i.countDown
                            ? i.countDown
                            : dayjs(i.startTime * 1000).format('MM-DD h:mm a')
                        }
                      </span>
                    </div>
                  </div>
                  <div className="room-info">
                    <div className="name">{i.name}</div>
                    <div className="desc">{i.description}</div>
                  </div>
                </div>
              )
            })
          }
        </div>
        {
          // this.state.roomList && this.state.roomList.length == 0 && (
          <div className="null-state">
            <span>
              {this.state.lang.noAc}
            </span>
            <div className="btn" onClick={() => { this.goCreate() }}>
              {this.state.lang.create}
            </div>
          </div>
          // )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/partyroom/index.js